import { render, staticRenderFns } from "./UserNameInput.vue?vue&type=template&id=6c3a8e48"
import script from "./UserNameInput.vue?vue&type=script&lang=js"
export * from "./UserNameInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports